"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TEASER_CONTENT_POSITION_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_CONTENT_POSITION_TYPE;
  }
});
Object.defineProperty(exports, "TEASER_STYLE_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_STYLE_TYPE;
  }
});
Object.defineProperty(exports, "TEASER_TYPE", {
  enumerable: true,
  get: function () {
    return _Teaser.TEASER_TYPE;
  }
});
Object.defineProperty(exports, "Teaser", {
  enumerable: true,
  get: function () {
    return _Teaser.Teaser;
  }
});
var _Teaser = require("b2b-components/core/components/CMS/Teaser/Teaser");
require("./Teaser.scss");
//# sourceMappingURL=Teaser.js.map